import { useAttachMatchTreeContext } from '@fs/zion-attach-match-tree-provider'

/**
 * Custom hook to retrieve attachment and match data for a person
 *
 * This hook fetches both attachment and match data for a specified person ID
 * and combines them for convenient access in UI components that need to display
 * attachment status.
 *
 * @param {string} personId - The ID of the person to retrieve attachment data for
 * @returns {Object} An object containing:
 *   - attachment {string|null} - The attachment ID if one exists
 *   - match {string|null} - The match ID if one exists
 *   - attachmentOrMatchId {string|null} - Either the attachment or match ID (attachment takes precedence)
 *
 * @example
 * const { attachment, match, attachmentOrMatchId } = usePersonAttachmentData('L2SP-Q93');
 * // Now you can determine which icon to show based on these values
 */
export const usePersonAttachmentData = (personId) => {
  const { getAttachmentDataByPersonId, getPossibleMatchDataByPersonId } = useAttachMatchTreeContext()

  const attachment = getAttachmentDataByPersonId(personId)
  const match = getPossibleMatchDataByPersonId(personId)
  const attachmentOrMatchId = attachment || match

  return { attachment, match, attachmentOrMatchId }
}
